export const locale = {
  lang: 'fr',
  data: {
    TITLE: 'ડિજિટલ ઓર્ડર બુક',
    SORT_INFO: 'ડિજિટલ ઓર્ડર બૂક એક વેબ એપ્લિકેશન છે જે મોબાઇલ એપ્લિકેશન નો ઉપયોગ કર્યા વગર  વેબસાઇટ દ્વારા મેનુફેક્ચરર અને ડીલર્સ ના ઓર્ડર લે છે અને મેનેજ કરે છે.  ડિજિટલ ઓર્ડર બૂક એક ઓનલાઈન ઓર્ડર મેનેજમેંટ સિસ્ટમ છે જેનાથી યુઝર સિંગલ ક્લિક કરી ને ઓર્ડર મેનેજ કરી શકે છે.'
  
}
}
